export const todosLosPaises = [
  // --- PRIORIDAD: AMÉRICA LATINA ---
  { nombre: "Argentina", codigo: "AR" },
  { nombre: "Bolivia", codigo: "BO" },
  { nombre: "Brasil", codigo: "BR" },
  { nombre: "Chile", codigo: "CL" },
  { nombre: "Colombia", codigo: "CO" },
  { nombre: "Costa Rica", codigo: "CR" },
  { nombre: "Cuba", codigo: "CU" },
  { nombre: "Ecuador", codigo: "EC" },
  { nombre: "El Salvador", codigo: "SV" },
  { nombre: "Guatemala", codigo: "GT" },
  { nombre: "Haití", codigo: "HT" },
  { nombre: "Honduras", codigo: "HN" },
  { nombre: "México", codigo: "MX" },
  { nombre: "Nicaragua", codigo: "NI" },
  { nombre: "Panamá", codigo: "PA" },
  { nombre: "Paraguay", codigo: "PY" },
  { nombre: "Perú", codigo: "PE" },
  { nombre: "Puerto Rico", codigo: "PR" },
  { nombre: "República Dominicana", codigo: "DO" },
  { nombre: "Uruguay", codigo: "UY" },
  { nombre: "Venezuela", codigo: "VE" },

  // --- RESTO DEL MUNDO ---
  { nombre: "Afganistán", codigo: "AF" },
  { nombre: "Albania", codigo: "AL" },
  { nombre: "Alemania", codigo: "DE" },
  { nombre: "Andorra", codigo: "AD" },
  { nombre: "Angola", codigo: "AO" },
  { nombre: "Arabia Saudita", codigo: "SA" },
  { nombre: "Argelia", codigo: "DZ" },
  { nombre: "Armenia", codigo: "AM" },
  { nombre: "Australia", codigo: "AU" },
  { nombre: "Austria", codigo: "AT" },
  { nombre: "Azerbaiyán", codigo: "AZ" },
  { nombre: "Bahamas", codigo: "BS" },
  { nombre: "Bangladés", codigo: "BD" },
  { nombre: "Barbados", codigo: "BB" },
  { nombre: "Bélgica", codigo: "BE" },
  { nombre: "Belice", codigo: "BZ" },
  { nombre: "Benín", codigo: "BJ" },
  { nombre: "Bielorrusia", codigo: "BY" },
  { nombre: "Birmania (Myanmar)", codigo: "MM" },
  { nombre: "Bosnia y Herzegovina", codigo: "BA" },
  { nombre: "Botsuana", codigo: "BW" },
  { nombre: "Brunéi", codigo: "BN" },
  { nombre: "Bulgaria", codigo: "BG" },
  { nombre: "Burkina Faso", codigo: "BF" },
  { nombre: "Burundi", codigo: "BI" },
  { nombre: "Bután", codigo: "BT" },
  { nombre: "Cabo Verde", codigo: "CV" },
  { nombre: "Camboya", codigo: "KH" },
  { nombre: "Camerún", codigo: "CM" },
  { nombre: "Canadá", codigo: "CA" },
  { nombre: "Catar", codigo: "QA" },
  { nombre: "Chad", codigo: "TD" },
  { nombre: "China", codigo: "CN" },
  { nombre: "Chipre", codigo: "CY" },
  { nombre: "Ciudad del Vaticano", codigo: "VA" },
  { nombre: "Comoras", codigo: "KM" },
  { nombre: "Corea del Norte", codigo: "KP" },
  { nombre: "Corea del Sur", codigo: "KR" },
  { nombre: "Costa de Marfil", codigo: "CI" },
  { nombre: "Croacia", codigo: "HR" },
  { nombre: "Dinamarca", codigo: "DK" },
  { nombre: "Dominica", codigo: "DM" },
  { nombre: "Egipto", codigo: "EG" },
  { nombre: "Emiratos Árabes Unidos", codigo: "AE" },
  { nombre: "Eritrea", codigo: "ER" },
  { nombre: "Eslovaquia", codigo: "SK" },
  { nombre: "Eslovenia", codigo: "SI" },
  { nombre: "España", codigo: "ES" },
  { nombre: "Estados Unidos", codigo: "US" },
  { nombre: "Estonia", codigo: "EE" },
  { nombre: "Etiopía", codigo: "ET" },
  { nombre: "Filipinas", codigo: "PH" },
  { nombre: "Finlandia", codigo: "FI" },
  { nombre: "Fiyi", codigo: "FJ" },
  { nombre: "Francia", codigo: "FR" },
  { nombre: "Gabón", codigo: "GA" },
  { nombre: "Gambia", codigo: "GM" },
  { nombre: "Georgia", codigo: "GE" },
  { nombre: "Ghana", codigo: "GH" },
  { nombre: "Granada", codigo: "GD" },
  { nombre: "Grecia", codigo: "GR" },
  { nombre: "Guinea", codigo: "GN" },
  { nombre: "Guinea Ecuatorial", codigo: "GQ" },
  { nombre: "Guyana", codigo: "GY" },
  { nombre: "Hungría", codigo: "HU" },
  { nombre: "India", codigo: "IN" },
  { nombre: "Indonesia", codigo: "ID" },
  { nombre: "Irak", codigo: "IQ" },
  { nombre: "Irán", codigo: "IR" },
  { nombre: "Irlanda", codigo: "IE" },
  { nombre: "Islandia", codigo: "IS" },
  { nombre: "Israel", codigo: "IL" },
  { nombre: "Italia", codigo: "IT" },
  { nombre: "Jamaica", codigo: "JM" },
  { nombre: "Japón", codigo: "JP" },
  { nombre: "Jordania", codigo: "JO" },
  { nombre: "Kazajistán", codigo: "KZ" },
  { nombre: "Kenia", codigo: "KE" },
  { nombre: "Kirguistán", codigo: "KG" },
  { nombre: "Kuwait", codigo: "KW" },
  { nombre: "Laos", codigo: "LA" },
  { nombre: "Letonia", codigo: "LV" },
  { nombre: "Líbano", codigo: "LB" },
  { nombre: "Liberia", codigo: "LR" },
  { nombre: "Libia", codigo: "LY" },
  { nombre: "Liechtenstein", codigo: "LI" },
  { nombre: "Lituania", codigo: "LT" },
  { nombre: "Luxemburgo", codigo: "LU" },
  { nombre: "Macedonia del Norte", codigo: "MK" },
  { nombre: "Madagascar", codigo: "MG" },
  { nombre: "Malasia", codigo: "MY" },
  { nombre: "Malaui", codigo: "MW" },
  { nombre: "Maldivas", codigo: "MV" },
  { nombre: "Malí", codigo: "ML" },
  { nombre: "Malta", codigo: "MT" },
  { nombre: "Marruecos", codigo: "MA" },
  { nombre: "Mauricio", codigo: "MU" },
  { nombre: "Mauritania", codigo: "MR" },
  { nombre: "Micronesia", codigo: "FM" },
  { nombre: "Moldavia", codigo: "MD" },
  { nombre: "Mónaco", codigo: "MC" },
  { nombre: "Mongolia", codigo: "MN" },
  { nombre: "Montenegro", codigo: "ME" },
  { nombre: "Mozambique", codigo: "MZ" },
  { nombre: "Namibia", codigo: "NA" },
  { nombre: "Nepal", codigo: "NP" },
  { nombre: "Níger", codigo: "NE" },
  { nombre: "Nigeria", codigo: "NG" },
  { nombre: "Noruega", codigo: "NO" },
  { nombre: "Nueva Zelanda", codigo: "NZ" },
  { nombre: "Omán", codigo: "OM" },
  { nombre: "Países Bajos", codigo: "NL" },
  { nombre: "Pakistán", codigo: "PK" },
  { nombre: "Palaos", codigo: "PW" },
  { nombre: "Palestina", codigo: "PS" },
  { nombre: "Papúa Nueva Guinea", codigo: "PG" },
  { nombre: "Polonia", codigo: "PL" },
  { nombre: "Portugal", codigo: "PT" },
  { nombre: "Reino Unido", codigo: "GB" },
  { nombre: "República Centroafricana", codigo: "CF" },
  { nombre: "República Checa", codigo: "CZ" },
  { nombre: "República del Congo", codigo: "CG" },
  { nombre: "República Democrática del Congo", codigo: "CD" },
  { nombre: "Ruanda", codigo: "RW" },
  { nombre: "Rumania", codigo: "RO" },
  { nombre: "Rusia", codigo: "RU" },
  { nombre: "Samoa", codigo: "WS" },
  { nombre: "San Marino", codigo: "SM" },
  { nombre: "Senegal", codigo: "SN" },
  { nombre: "Serbia", codigo: "RS" },
  { nombre: "Seychelles", codigo: "SC" },
  { nombre: "Sierra Leona", codigo: "SL" },
  { nombre: "Singapur", codigo: "SG" },
  { nombre: "Siria", codigo: "SY" },
  { nombre: "Somalia", codigo: "SO" },
  { nombre: "Sri Lanka", codigo: "LK" },
  { nombre: "Sudáfrica", codigo: "ZA" },
  { nombre: "Sudán", codigo: "SD" },
  { nombre: "Suecia", codigo: "SE" },
  { nombre: "Suiza", codigo: "CH" },
  { nombre: "Surinam", codigo: "SR" },
  { nombre: "Tailandia", codigo: "TH" },
  { nombre: "Taiwán", codigo: "TW" },
  { nombre: "Tanzania", codigo: "TZ" },
  { nombre: "Tayikistán", codigo: "TJ" },
  { nombre: "Timor Oriental", codigo: "TL" },
  { nombre: "Togo", codigo: "TG" },
  { nombre: "Tonga", codigo: "TO" },
  { nombre: "Trinidad y Tobago", codigo: "TT" },
  { nombre: "Túnez", codigo: "TN" },
  { nombre: "Turkmenistán", codigo: "TM" },
  { nombre: "Turquía", codigo: "TR" },
  { nombre: "Ucrania", codigo: "UA" },
  { nombre: "Uganda", codigo: "UG" },
  { nombre: "Uzbekistán", codigo: "UZ" },
  { nombre: "Vanuatu", codigo: "VU" },
  { nombre: "Vietnam", codigo: "VN" },
  { nombre: "Yemen", codigo: "YE" },
  { nombre: "Zambia", codigo: "ZM" },
  { nombre: "Zimbabue", codigo: "ZW" }
];